import { Component, Input, OnInit } from '@angular/core';
import { ShoppingCartService } from '../../services/shoppingcart.service';

@Component({
  selector: 'app-truck',
  templateUrl: './truck.component.html',
  styleUrls: ['./truck.component.scss']
})
export class TruckComponent implements OnInit {

  @Input() link: string[];

  constructor(
    public shoppingCartService: ShoppingCartService
  ) { }

  ngOnInit(): void {
  }

}
